import Vue from "vue";
import router from "../router";
import { setCommon } from "@/utils/request";
import { Ajax } from "@/utils/ajax";
import { setMetaData } from "@/utils";
import { methodList } from "@/request/requestNotMessage";
import loggerJSON from "@/doc/config/logger.json";
type FunctionOrNull = Function | null;
export default class InnerRequest {
  static responseTime: string;
  private flag = '';
  /*
   * 传入参数：
   * apiService， 对应的服务，类似请求URL；
   * method, 请求对应的方法，具体的服务名称，例如getList之类的
   * isTransfer，请求返回的response是否需要转为对象类型，目前服务端返回的文件下载格式是不统一的
   * isCommon，请求体是否需要setCommonin
   * */
  constructor(
    protected apiService: any,
    protected method: Function,
    protected isTransfer = true,
    protected isCommon = true
  ) {
  }
  /*
   * 处理请求的函数，参数为具体的请求体
   * */
  handleHttp(arg: any) {
    return new Promise((resolve, reject) => {
      (async () => {
        let _service = this.apiService,
          _method = this.method;
        this.isCommon && arg.setCommonin(setCommon());
        console.log(_service, _method, "apiService");
        let _fuc = _method.bind(_service);
        let _requestTime = "";
        console.log(arg)
        console.log(arg,"---------+-------------")
        let _res = await _fuc(arg, setMetaData(), (err: any, response: any) => {
          _res.requestTime = "" + new Date().getTime();
          console.log(response, "response");
          let _o = _res.a.o ? _res.a.o : _res.a.a.a.responseURL;//_res.a.a.o;
          let _url = new URL(_o);
          if (
            this.validateReport({ url: _url.pathname, origin: _url.origin })
          ) {
            let _header = _res.a.headers ? _res.a.headers : _res.a.a.headers;
            this.handlerReport(_header, _o, _res.requestTime);
            _res.url = _res.a.headers ? _res.a.headers : _res.a.a.headers;
          }
          console.log(_url, "url");
          _res.flag = _url.pathname;
          this.flag = _url.pathname;
          response && resolve(this.isTransfer ? response.toObject() : response);
          err && reject(err);
        });
        console.log("handleHttp", _res);
      })();
    })
      .then((response: any) => {
        response.loading = false;
        this.handleResponse(response, null);
        console.log(response, "response", this.apiService);
        return response;
      })
      .catch((err: any) => {
        (methodList.includes(this.flag) && +err.code === 7) ? null :
          this.handleError(err);
      });
  }
  /*
   * 是否需要上报请求，对应config/logger.json
   * */
  validateReport({ url, origin }: any) {
    return loggerJSON.list.includes(url) && loggerJSON.request.includes(origin);
  }
  /*
   * 上报请求
   * */
  handlerReport(_header: any, _o: any, requestTime: any) {
    console.log(requestTime, "handlerReport");
    Ajax.post(
      loggerJSON.origin.includes(location.origin)
        ? "https://h5-logger.okredito.com/api"
        : "https://logger.okredito.console.mx.fg-example.com/api",
      // "https://h5-logger.okredito.com/api",
      // "http://172.29.140.193:3000/api",
      {
        // ...arg.array,
        // ...this.request.a.headers.b,
        ..._header.b,
        ...{
          // RequestURL: this.request.a.o,
          RequestURL: _o,
          RequestTime: requestTime,
          // RequestTime: "" + new Date().getTime(),
          ReceivedTime: "" + new Date().getTime()
        }
      },
      null
    );
  }
  /*
   * 处理返回结果
   * */
  handleResponse(res: any, fuc: FunctionOrNull) {
    let _status = res.commonout ? res.commonout : res;
    console.log(_status, methodList.includes(res.flag), 'handleResponse');

    switch (_status.code) {
      case 0:
        res.right = true;
        break;
      case 102:
        res.right = true;
        break;
      case 100100:
        this.routerNavigate("./login");
        break;
      case 100101:
        this.routerNavigate("./login");
        break;
      case 100103:
        res.right = false;
        break;
      default:
        res.right = false;
        (methodList.includes(res.flag) && +_status.code === 7) ? null :
          this.errorAlert(_status.errmsg ? _status.errmsg : _status.message);
    }
    return fuc ? fuc(res) : res;
  }
  /*
   * 处理错误
   * */
  handleError(err: any) {

    console.log(err, "errorMsg", this);
    err.code && err.code == 16
      ? router.push("./login")
      :
      this.errorAlert(err.errmsg ? err.errmsg : err.message);
  }
  /*
   * 错误弹窗
   * */
  errorAlert(message: string) {
    Vue.prototype.$message({
      message: message,
      type: "error"
    });
  }
  /*
   * 路由跳转
   * */
  routerNavigate(router: string) {
    Vue.prototype.$selfRouter.push(router);
  }
}
